import axiosInstance from '@/shared/api/axios';
import type { ApiPackagesNextNameResponse } from '@/shared/types/api/packages';

// POST /packages/next-name — atomically increments the monthly counter and
// returns the next package name ("YYMM-N"). Allowed for both client users and
// admin staff. Increments on every call, even when no package is created.
export const apiPackagesNextName = async (): Promise<ApiPackagesNextNameResponse> => {
  const { data } = await axiosInstance.post<ApiPackagesNextNameResponse>('/packages/next-name');
  return data;
};
